var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2488_620)","key":0},React.createElement("path",{"d":"M10 1.17838L8.82162 0L4.99999 3.82161L1.17838 0L0 1.17838L3.82161 4.99999L0 8.82162L1.17838 10L4.99999 6.17839L8.8216 10L9.99997 8.82162L6.17839 4.99999L10 1.17838Z","fill":"#667778"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2488_620"},React.createElement("rect",{"width":"10","height":"10","fill":"white"})))]);
}

Close.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = Close;

Close.default = Close;
